import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDataFetchingClient } from 'data-fetching-client';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import unescapedText from 'I18n/utils/unescapedText';
import { useGetInvoicesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { GET_INVOICES_QUERY } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.dfc.new';
const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 30000;
const POLL_PAGE_LENGTH = 100;
export function usePollInvoicePaid(invoiceId) {
  const history = useHistory();
  const location = useLocation();
  const client = useDataFetchingClient();
  const [isPolling, setIsPolling] = useState(Boolean(invoiceId));
  const resolvedRef = useRef(false);
  const {
    data
  } = useGetInvoicesQuery({
    variables: {
      pageLength: POLL_PAGE_LENGTH,
      filterStatuses: ['past_due']
    },
    skip: !invoiceId || !isPolling,
    fetchPolicy: 'network-only',
    pollInterval: POLL_INTERVAL_MS
  });
  const onInvoicePaymentSuccess = useCallback(confirmed => {
    void client.refetchQueries({
      include: [GET_INVOICES_QUERY]
    });
    if (confirmed) {
      FloatingAlertStore.addAlert({
        message: unescapedText('invoices.invoicePaidSuccessfully'),
        type: 'success'
      });
    }
    history.replace(location.pathname);
  }, [client, history, location.pathname]);
  const success = useCallback(confirmed => {
    if (resolvedRef.current) return;
    resolvedRef.current = true;
    setIsPolling(false);
    onInvoicePaymentSuccess(confirmed);
  }, [onInvoicePaymentSuccess]);
  useEffect(() => {
    if (!invoiceId) return;
    const timeoutId = setTimeout(() => success(false), POLL_TIMEOUT_MS);
    return () => clearTimeout(timeoutId);
  }, [invoiceId, success]);
  useEffect(() => {
    var _data$results;
    if (!invoiceId || !data) return;
    const isStillPastDue = (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.some(inv => inv.objectId === invoiceId);
    if (!isStillPastDue) {
      success(true);
    }
  }, [invoiceId, data, success]);
  return {
    isPolling,
    onInvoicePaymentSuccess
  };
}